import {getElementByTagName, getEntity} from "../utils";

const createBuyButton = (hash) => {
    const main = getElementByTagName('main');

    for (let item of Array.from(main.childNodes)) {
        if (item.classList.contains('buyButtonContainer')) {
            main.removeChild(item);
        }
    }

    const entity = getEntity(hash);
    const buyButtonContainer = document.createElement('div');
    buyButtonContainer.classList.add('buyButtonContainer');

    const button = document.createElement('a');
    button.href = generateEmail(entity);
    button.innerText = generateBuyButtonText(entity.price);

    buyButtonContainer.append(button);
    main.append(buyButtonContainer);
};

const generateBuyButtonText = (price) => `купить за ${price} ₽`;
const generateEmail = (entity) => `mailto:office@smff.ru?subject=Хочу купить ${entity.name}&body=Хочу купить 1шт. ${entity.name} за ${entity.price} ₽`;

export default createBuyButton;
